const initialState = {
  searchText: ''
};

export function search(state = initialState, action) {
  switch (action.type) {
  case 'UPDATE_SEARCH_TEXT':
    return Object.assign({}, state, { searchText: action.payload });
  default:
    return state;
  }
}
